export function docsHref(path = '') {
  return `https://docs.evervault.com/${path.replace(/^\//, '')}`;
}

export function openDocs(path = '') {
  window.open(docsHref(path), '_blank');
}
